<template>
  <div class="px-8 py-4">
    <h1>Динамический расчет формул</h1>
    <div class="variables-input">
      <h3>Переменные</h3>
      <div class="flex flex-wrap">
        <div
          v-for="(variable, index) in variables"
          :key="index"
          class="flex mb-2 width-30">
          <label for="a">{{ variable.key }}:</label>
          <sInput
            class="ml-4"
            :value.sync="variable.value"/>
        </div>
      </div>
    </div>
    <div>
      <sCheckbox
        v-model="showFormula.useSpace"
        class="mb-4"
        label="useSpace"/>
      <ShowFormula
        :formula-string="formulas[0]"
        :use-space="showFormula.useSpace"/>
    </div>
    <div
      v-for="(formula, index) in formulas"
      :key="index"
      class="mb-5"
      style="display: grid; grid-template-columns: 500px 200px; gap: 10px;">
      <AddMathFormula
        :formula="formulas[index]"
        :variables="variables"
        @result="val => onResult(val, index)"
        @update:error="val => onError(val, index)"
        @update:formula="value => formulas[index] = value"/>
      <p class="ml4 my-auto">
        Результат: {{ results[index] }}
      </p>
    </div>
  </div>
</template>

<script>
import AddMathFormula from 'components/tenders/critetia/AddMathFormula.vue'
import ShowFormula from 'components/common/ShowFormula.vue'

export default {
  name: 'TestMath',
  components: {
    AddMathFormula,
    ShowFormula
  },
  data() {
    return {
      showFormula: {
        useSpace: false,
      },
      formulas: [
        'PRICE*(if(A==1,100,B)*0.01*(1+0.13*((2-C)*D)/365) + if(A==1,0,if(A==2,100-B,F))*0.01*(1+0.13*((2-H)*I)/365) + if(A==3,100-B-F,0)*0.01*(1+0.13*((2-K)*L)/365))',
        'if(A != 0 & B==7, B + A, if(A == 0, 32, C * PRICE - C)) * F',
        'if(A != 0 & B==7, B + A, if(A == 0, 32, C * PRICE - C)) *',
        'if(A != 0 & B==7, B + A, if((A == 0, 32, C * PRICE - C))',
        'if(A != 0 & B==7, B + A, if()A == 0, 32, C * PRICE - C))',
        'if(A != 0 & B==7, B ++ A, if(A == 0, 32, C * PRICE - C))',
        '-if(A != 0 & B==7, B + A, if(A == 0, 32, C * PRICE - C))',
        'A/0',
        'A\\0',
        'if(A>=0,B+A,if(A==0;32, D*PRICE-C)) + A + B + C'
      ],
      variables: [
        { key: 'A', value: 1 },
        { key: 'B', value: 1 },
        { key: 'C', value: 1 },
        { key: 'D', value: 1 },
        { key: 'PRICE', value: 1 }
      ],
      results: [
        null,
      ],
      errors: []
    }
  },
  methods: {
    onResult(result, index) {
      this.$set(this.results, index, result)
      this.$set(this.errors, index, null)
    },
    onError(error, index) {
      this.$set(this.results, index, null)
      this.$set(this.errors, index, error)
    }
  }
}
</script>
